module.exports = __webpack_public_path__ + "static/media/the-massive-farms-emerging-beneath-our-cities.f9a859ee.jpg";